import styled from 'styled-components'
import { Box } from 'vvs-uikit'

export const QuestDetailBanner = styled(Box)<{ bg?: string; disabled: boolean }>`
  width: 100%;
  background-image: ${({ disabled, bg }) =>
    disabled ? `url('/images/vvsGotchi/bg_gray.png')` : `url('${bg || '/images/vvsGotchi/bg_violet_red.png'}')`};
  background-size: cover;
  background-position: center;
  padding: 16px 15px 32px 15px;
`
